import Component from "../../../assets/scripts/modules/component";
import {BackgroundImage} from "../../atoms/background-image/background-image-generic";
import fireCustomEvent from "../../../vendor/scripts/fabrique/modules/fire-custom-event";

const InfiniteScroll = require('infinite-scroll');

class InfiniteScrollComponent extends Component {

  init() {
    this.filterFields = this.element.querySelectorAll('input, select');
    this.itemClass = this.element.dataset.item;
    this.itemContainer = document.querySelector('[data-role=infinite-scroll-items]');

    this.filterFields.forEach(field => {
      field.addEventListener('change', () => this.refresh());
    });

    this.create();
  }

  create() {
    this.infScroll = new InfiniteScroll(this.itemContainer, {
      path: this.getPath.bind(this),
      append: false,
      checkLastPage: false,
      prefill: false,
      responseType: 'text',
      outlayer: false,
      scrollThreshold: 400,
      elementScroll: false,
      loadOnScroll: true,
      history: false,
      historyTitle: true,
      hideNav: undefined,
      status: undefined,
      button: undefined,
      onInit: undefined,
      debug: false,
    });

    this.infScroll.on('request', () => {
      this.showSpinner();
    });

    this.infScroll.on('load', (response, url) => {
      this.hideSpinner();
      // parse response text into JSON data
      const data = JSON.parse(response);
      // append items
      const items = data.items;
      const lastPage = data.lastPage;
      const fragment = this.buildItemsFragment(items);

      if (lastPage) {
        this.infScroll.canLoad = false;
      }

      for (const element of fragment.querySelectorAll('.background-image')) {
        element.instance = new BackgroundImage('background-image', element, { onRightAway: true });
      }

      for (const element of fragment.querySelectorAll('[data-role=permission-required]')) {
        element.addEventListener('click', () => {
          event.preventDefault();
          fireCustomEvent('copyright-confirm:start', {detail: element.dataset.target});
        });
      }

      this.infScroll.appendItems(items, fragment);
    });
  }

  getPath() {
    const filterValues = [...this.filterFields].map(field => [field.getAttribute('name'), field.value].join('='));
    if (this.infScroll) {
      filterValues.push(`page=${this.infScroll.pageIndex}`);
    }
    return this.element.dataset.url + '?' + filterValues.join('&');
  }

  buildItemsFragment(items) {
    const fragment = document.createDocumentFragment();
    items.forEach(item => {
      const element = document.createElement('div');
      element.classList.add(this.itemClass);
      element.innerHTML = item;
      fragment.appendChild(element);
    });
    return fragment;
  }

  showSpinner() {
    this.element.classList.add('is-loading');
  }

  hideSpinner() {
    this.element.classList.remove('is-loading');
  }

  refresh() {
    this.infScroll.destroy();
    this.itemContainer.innerHTML = '';
    this.create();
    this.infScroll.loadNextPage();
  }
}

for (const element of document.querySelectorAll('.infinite-scroll-container')) {
  element.instance = new InfiniteScrollComponent('infinite-scroll', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/structures/infinite-scroll/infinite-scroll.js